<pos-manager-header [title]="'posManager.totalSaleByMenuCategory' | transloco" [hasBackDetailedButton]="true"
                    [backUrl]="'../realtime-info/..'"></pos-manager-header>
<ion-content>
  <div class="ion-padding custom-flex-col">
    <div class="segment-container">
      <form [formGroup]="form">
        <ion-segment
          mode="md"
          formControlName="selectedMealId">
          <ion-segment-button [value]="MealTime.Breakfast">
            <ion-label>{{ 'meals.breakfast' | transloco }}</ion-label>
          </ion-segment-button>
          <ion-segment-button [value]="MealTime.Lunch">
            <ion-label>{{ 'meals.lunch' | transloco }}</ion-label>
          </ion-segment-button>
          <ion-segment-button [value]="MealTime.Dinner">
            <ion-label>{{ 'meals.dinner' | transloco }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </form>
    </div>

    <div class="columns-accordion">
     <ng-template #noCategories>
       <div>{{ 'posManager.noCategoriesFound' | transloco }}</div>
     </ng-template>

     <ng-template #noItems>
       <div class="columns-accordion__columns_content">
         <div class="columns-accordion__column-details">{{ 'posManager.noItemsFound' | transloco }}</div>
       </div>
     </ng-template>

     <div *ngIf="salesByMenuCategory && (salesByMenuCategory | objectKeys).length === 0">
       <ng-container *ngTemplateOutlet="noCategories"></ng-container>
     </div>
     <div *ngIf="salesByMenuCategory && (salesByMenuCategory | objectKeys).length > 0">
       <div class="columns-accordion__columns-header">
         <div class="columns-accordion__column-details columns-accordion__sortable-header" (click)="toggleSort('name')">
           {{ 'posManager.details' | transloco }}
           <ion-icon *ngIf="sortColumn === 'name'" [name]="'name' | sortIcon: sortColumn : sortDirection"></ion-icon>
         </div>
         <div class="columns-accordion__column-qty columns-accordion__sortable-header" (click)="toggleSort('quantity')">
           {{ 'posManager.qty' | transloco }}
           <ion-icon *ngIf="sortColumn === 'quantity'" [name]="'quantity' | sortIcon: sortColumn : sortDirection"></ion-icon>
         </div>
         <div class="columns-accordion__column-total columns-accordion__sortable-header" (click)="toggleSort('total')">
           {{ 'posManager.totalSales' | transloco }}
           <ion-icon *ngIf="sortColumn === 'total'" [name]="'total' | sortIcon: sortColumn : sortDirection"></ion-icon>
         </div>
       </div>

       <ion-accordion-group multiple="true">
         <ion-accordion
           *ngFor="let categoryName of ((salesByMenuCategory | objectKeys) | categorySort: sortColumn : sortDirection : salesByMenuCategory); trackBy: trackByCategory"
           [value]="categoryName"
           toggleIconSlot="start">
           <ion-item slot="header" color="light">
             <div class="columns-accordion__columns_content">
               <div class="columns-accordion__column-details">{{ categoryName }}</div>
               <div class="columns-accordion__column-qty">{{ categoryName | categoryTotalQuantity: salesByMenuCategory }}</div>
               <div class="columns-accordion__column-total">{{ (categoryName | categoryTotalSales: salesByMenuCategory) | currency }}</div>
             </div>
           </ion-item>
           <div class="ion-padding" slot="content">
             <ng-container *ngIf="salesByMenuCategory?.[categoryName]?.length > 0; else noItems">
               <div
                 class="columns-accordion__columns_content"
                 *ngFor="let item of salesByMenuCategory?.[categoryName]; trackBy: trackByItem">
                 <div class="columns-accordion__column-details">{{ item.name }}</div>
                 <div class="columns-accordion__column-qty">{{ item.total_quantity }}</div>
                 <div class="columns-accordion__column-total">{{ (item.total_sales || 0) | currency }}</div>
               </div>
             </ng-container>
             <ng-template #noItems>
               <ng-container *ngTemplateOutlet="noItems"></ng-container>
             </ng-template>
           </div>
         </ion-accordion>
       </ion-accordion-group>
     </div>

    </div>

  </div>


</ion-content>
